// import library
import axios from "axios";
import { useContext, useState } from "react";
// import context
import { AuthContext } from "../../context";
// import component
import AuthIndex from "../../components/Account/AuthIndex";
// import file
import { env } from "../../env";
import { NavLink } from "react-router-dom";
import ErrorModal from "../../components/Modal/ErrorModal";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { logEvent } from "../../analytics";

const Login = () => {
    // variables
    const authContext = useContext(AuthContext);

    const [isLoader, setIsLoader] = useState(false);
    const [showPasssword, setShowPasssword] = useState(false);
    const [focuField, setFocusField] = useState('none');
    const [errors, setErrors] = useState({});
    const [credentialError, setCredentialError] = useState("");
    const errorStyle = "text-danger-normal font-bold text-xs mt-0.5";
    const remember = localStorage.getItem('remember');
    const [rMe, setrMe] = useState(remember == 1 ? 'true' : 'false');
    const [inputs, setInputs] = useState({
        email: "",
        password: "",
    });

    // functions
    const validateValues = (inputValues) => {
        let errors = {};
        if (inputValues.email.trim().length === 0) {
            errors.email = true;
        }
        if (inputValues.password.trim().length === 0) {
            errors.password = true;
        }
        return errors;
    };
    const handleFocus = (e, name) => {
        e.preventDefault();
        setFocusField(name);
    };
    const handleModalDataFromChild = () => {
        setCredentialError("");
    };
    const handleChange = (e) => {
        e.preventDefault();
        setFocusField('none');
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        });
    };
    const handleRememberMe = (e) => {
        setrMe(!rMe);
        if(rMe === true || rMe === 'true') {
            localStorage.setItem('remember', 0);
        } else {
            localStorage.setItem('remember', 1);
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setFocusField('none');
        setErrors(validateValues(inputs));
        setCredentialError("");
        if (Object.keys(validateValues(inputs)).length === 0) {
            setIsLoader(true);
            const baseUrl = env.REACT_APP_API_URL;
            const headers = {
                "Accept" : "application/json",
                "Content-Type" : "application/json"
            };

            axios.post(baseUrl+"/api/Auth/login", {
                email: inputs.email,
                password: inputs.password
            }, { headers })
            .then((response) => {
                if(response.status === 200) {
                    logEvent('login_page', 'auth', 'login', inputs.email);
                    axios.get(baseUrl+"/api/Company/GetCompanyInfo", { headers: {
                        "Content-Type" : "application/json",
                        "Authorization" : `Bearer ${response.data.accessToken}`
                    }})
                    .then((response1) => {
                        axios.post(baseUrl+"/api/Auth/credentials", {
                            username: inputs.email, 
                            password: inputs.password 
                        }, { headers })
                        .then((response2) => {
                            if(rMe === true || rMe === 'true') {
                                var expiryDate = Math.floor(+new Date() / 1000) + 30 * 24 * 60 * 60; 
                            } else {
                                var expiryDate = Math.floor(+new Date() / 1000) + 2 * 24 * 60 * 60; 
                            }
                            const userData = {
                                'id' : response2.data.loginuser_id,
                                'name' : response2.data.name,
                                'email' : response2.data.email,
                                'apiKey' : response1.data.data.apiKey,
                                'userName' : inputs.email,
                                'password' : inputs.password,
                                'expiryDate' : expiryDate,
                                'userCompany' : response2.data.userCompany
                            };

                            authContext.login(response.data.accessToken, userData);
                        });
                    });
                } else {
                    setCredentialError('Something went wrong, Try Again');
                    setTimeout(() => {
                        setCredentialError('');
                    }, 5000);
                    setIsLoader(false);
                }
            }).catch((error) => {
                if (error.response) {
                    if(error.response.status === 401) {
                        setCredentialError('Please enter valid email or password');
                        
                    } else {
                        setCredentialError('Something went wrong, Try Again');
                    }
                    setTimeout(() => {
                        setCredentialError('');
                    }, 5000);
                    setIsLoader(false);
                }
            });
        }
    };
    
    return (
        <div className="relative max-w-md sm:max-w-full">
            <div className="bg-auth-light flex flex-col items-center justify-center min-h-screen top-0 h-full">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="bg-white p-4 sm:p-8 rounded-3xl shadow-around">
                        <AuthIndex />
                        <div className="space-y-6">
                            <div className="text-light-400 text-center">Please enter your email address and password</div>
                            <div className="space-y-4">
                                <div>
                                    <div className={(focuField === 'email' ? 'border-blue-normal' : 'border-black-100') + " flex border rounded-lg p-3 items-center"}>
                                        <img className="mr-2" src={`../../../assets/icons/auth/mail.svg`} />
                                        <input onFocus={(e) => handleFocus(e, 'email')} name="email" type="text" value={inputs.email} onChange={(e) => handleChange(e)} className="border-none focus:outline-none w-full placeholder:text-gray-dark" placeholder="Enter Address" />
                                    </div>
                                    {errors.email ? (
                                        <p className={errorStyle}>
                                            Email Field is required!!
                                        </p>
                                    ) : null}
                                </div>
                                <div>
                                    <div className={(focuField === 'password' ? 'border-blue-normal' : 'border-black-100') + " flex border rounded-lg p-3 items-center"}>
                                        <img className="mr-2" src={`../../../assets/icons/auth/lock.svg`} />
                                        <input onFocus={(e) => handleFocus(e, 'password')} name="password" type={showPasssword ? "text" : "password"} value={inputs.password} onChange={(e) => handleChange(e)} autoComplete="password" className="border-none focus:outline-none w-full placeholder:text-gray-dark" placeholder="Password" />
                                        <img onClick={(e) => setShowPasssword(!showPasssword)} className="cursor-pointer" src={`../../../assets/icons/auth/${showPasssword ? "show" : "hide"}.svg`} />
                                    </div>
                                    {errors.password ? (
                                        <p className={errorStyle}>
                                            Password Field is required!!
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <div className="flex justify-between items-center">
                                {/* remember me */}
                                <div className="flex items-center my-3">
                                    <label className="relative flex items-center cursor-pointer">
                                        <input name="rememberMe" type="checkbox" defaultChecked={rMe === 'true' ? true : false} onChange={(e) => handleRememberMe(e)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                            </svg>
                                        </span>
                                    </label>
                                    <div className="font-normal text-sm sm:text-base ml-2 text-light-400">Remember me</div>
                                </div>
                                {/* forgot password */}
                                <div>
                                    <NavLink to="/forgot-password" className="text-blue-normal text-base font-medium">
                                        Forgot Password
                                    </NavLink>
                                </div>
                            </div>
                            {/* submit button */}
                            <div>
                                {!isLoader ? 
                                    <button type="submit" className="font-semibold text-white bg-blue-normal border-blue-normal rounded-lg text-center w-full py-3 px-2 cursor-pointer tracking-wide">
                                        Sign in
                                    </button>
                                : 
                                    <button type="button" className="font-semibold text-white bg-blue-normal border-blue-normal rounded-lg text-center w-full py-3 px-2 cursor-wait tracking-wide">
                                        Please wait...
                                    </button>
                                }
                                
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="fixed bottom-3 right-4 text-xs text-light-400">v{env.REACT_APP_VERSION}</div>
            {credentialError ? (
                <ErrorModal icon={'error'} title={'Error'} message={credentialError} borderColor={'B01030'} bgColor={'FCE8EC'} setModalDataFromChild={handleModalDataFromChild}/>
            ) : null}
        </div>
    )
}

export default Login;